import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_191br80oqs: FaireBrandEntity = {
  token: "b_191br80oqs",
  type: "brand",
  name: "The Cotton & Canvas Co.",
  avatarUrl: "https://cdn.faire.com/fastly/2767b18c8815dc2d3015ddc8576ff362c359581f82e9b15b6082a38ad6c9247b.png",
  bannerUrl: "https://cdn.faire.com/fastly/f491b6370b3c126b2b7a982635b5065675b128158c1a6ccc461d6c517d1e2423.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/2767b18c8815dc2d3015ddc8576ff362c359581f82e9b15b6082a38ad6c9247b.png",
  heroImageUrl: "https://cdn.faire.com/fastly/f491b6370b3c126b2b7a982635b5065675b128158c1a6ccc461d6c517d1e2423.jpeg",
  location: "Garden Grove, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 115,
  isTopShop: true,
  isInsider: true,
  description: "Welcome to The Cotton & Canvas Co.! We believe in positivity. Beauty. And little bit of humor. From home decor to gifts, our items are made to order with the utmost attention and care. We are inspired by a little whimsy and delight and we work hard at creating pieces that reflect that. We hope you enjoy!",
  meta: {
    source: "api",
    importedAt: "2026-10-09T07:53:33.734Z",
    importedBy: "entity-db-cli"
  }
};
